<template>
	<a-accounting-top-bar
					v-model:filter="filter"
					@showForm="showForm()"
					:category="category"
					@search="doSearch"/>
	<div class="flex-1">
		<vxe-table border :loading="loading" height="auto" :data="dataList">
			<vxe-column title="编码" field="code"/>
			<vxe-column title="名称" field="name"/>
			<vxe-column title="助记码" field="mnemonics"/>
			<vxe-column title="性别" field="gender">
			<template #default="{row}">
                {{genderFormatter(row.gender)}}
              </template>
            </vxe-column>
			<vxe-column title="手机" field="telPhone"/>
			<vxe-column title="部门" field="departmentId">
              <template #default="{row}">
                {{deptNameFormat(row.departmentId)}}
              </template>
            </vxe-column>


			<vxe-column title="职称" field="professional"/>
			<vxe-column title="岗位" field="post"/>
			<vxe-column title="出生日期" field="birthDate"/>
			<vxe-column title="入职日期" field="onBoardingDate"/>
			<vxe-column title="离职日期" field="dimissionDate"/>
			<vxe-column title="备注" field="remark"/>
			<vxe-column title="操作" width="120">
				<template #default="{row}">
					<div class="actions">
						<span class="h-icon-edit" @click="showForm(row)"> 编辑</span>
						<span class="h-icon-trash" @click="remove(row)"> 删除</span>
					</div>
				</template>
			</vxe-column>
		</vxe-table>
	</div>
	<vxe-pager v-model:current-page="pageInfo.page" v-model:page-size="pageInfo.pageSize" v-model:total="pageInfo.total"/>
</template>

<script>
/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2019-2020金华企客观网络科技有限公司All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : </li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2020年08月08日</li>
 * <li>@author     : ____′↘企万慧</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
import AAccountingTopBar from "@/views/setting/AssistingAccounting/AAccountingTopBar.vue";

export default {
	name: "Employee",
	components: {AAccountingTopBar}
}
</script>

<script setup>
import setting from "@/api/setting";
import {ref, defineProps, h} from "vue";
import {usePageInject} from "./AAccountingCrud";
import {Employee} from "@/api/Auxiliary";
import {layer} from "@layui/layer-vue";
// import EmployeeForm from "@/views/setting/AssistingAccounting/form/EmployeeForm.vue";
import EmployeeForm from "@/views/salary/EmployeeForm.vue";
import {confirm} from "heyui.ext";

defineProps(['category'])
const dataList = ref([]);
const deptOptions = ref([]);
const filter = ref(null);

const loadList = () => {
	return Employee.list(Object.assign({filter: filter.value}, pageParams.value)).then(({data}) => {
		dataList.value = data.results;
		pageInfo.total = data.total;
	})
}

const {
	pageInfo,
	doSearch,
	pageParams,
	loading
} = usePageInject(loadList);

doSearch();

const showForm = (entity = null) => {
	let layerId = layer.open({
		title: "员工信息",
		shadeClose: false,
		closeBtn: false,
		zIndex: 1000,
		// area: ['auto', 'auto'],
    area: ['1000px', '85vh'],
		content: h(EmployeeForm, {
			id: entity ? entity.id : null,
			onClose: () => {
				layer.close(layerId);
				doSearch();
			},
			onSuccess: () => {
				layer.close(layerId);
				doSearch();
			}
		})
	});
}

 setting.accountingCategoryDetails.loadAuxiliaryAccountingDataByName(['DEPARTMENT', 'VENDOR']).then(({data}) => {
    deptOptions.value = data['DEPARTMENT'].map(val => {
      return {
        key: val.id,
        accountingCategoryId: val.categoryId,
        title: val.name
      }
    });
  })



const deptNameFormat = (deptId) =>{
	let idx = deptOptions.value.findIndex(dept=>dept.key===deptId);
	if (idx>-1) {
		return deptOptions.value[idx].title
	}
}


const genderFormatter =  (cellValue) => {
      return cellValue == 1 ? '男' : '女';
    }
const remove = (entity) => {
	confirm({
		content: `确认删除${entity.name}？`,
		async: true,
		onConfirm: (resolve) => {
			Employee.delete(entity.id).then(() => {
				resolve(true)
				loadList();
			}).catch(() => resolve(false))
		}
	})
}
</script>
